---
fr:
  market_prices:
    average: Prix moyen
    avg_power_prices_year: Prix moyen de l'électricité {year} [{currency_code}/MWh]
    heading: Prix du marché
    power_prices_year: Prix de l'électricité {year}
    price_factor: Facteur de prix [%]
    realized_price: Prix réalisé
    reservoir_fill:
      heading: Capacité de réservoir hydroélectrique norvégien
      y_axis_title: Pourcentage de remplissage
